import React from 'react';
import ExpedienteFormWizard from './expediente-form/ExpedienteFormWizard';

const ExpedienteForm = () => <ExpedienteFormWizard mode="create" />;

export default ExpedienteForm;
